import React from 'react';

const StatusBadge = ({ status, size = 'md' }) => {
  const getStatusConfig = (status) => {
    const configs = {
      'pending': {
        bg: 'bg-blue-100',
        text: 'text-blue-800',
        border: 'border-blue-200'
      },
      'under_investigation': {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800',
        border: 'border-yellow-200'
      },
      'resolved': {
        bg: 'bg-green-100',
        text: 'text-green-800',
        border: 'border-green-200'
      },
      'dismissed': {
        bg: 'bg-red-100',
        text: 'text-red-800',
        border: 'border-red-200'
      }
    };

    return configs[status] || configs['pending'];
  };

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const getStatusLabel = (status) => {
    const labels = {
      'pending': 'Pending',
      'under_investigation': 'Under Investigation',
      'resolved': 'Resolved',
      'dismissed': 'Dismissed'
    };
    return labels[status] || status;
  };

  const config = getStatusConfig(status);

  return (
    <span className={`
      inline-flex items-center rounded-full border font-medium
      ${config.bg} ${config.text} ${config.border}
      ${sizeClasses[size] || sizeClasses.md}
    `}>
      {getStatusLabel(status)}
    </span>
  );
};

export default StatusBadge;
